import { Dispatch } from 'redux';
import api from '../../api/api';


export const FETCH_DEPARTMENT_TEACHERS_REQUEST = 'FETCH_DEPARTMENT_TEACHERS_REQUEST';
export const FETCH_DEPARTMENT_TEACHERS_SUCCESS = 'FETCH_DEPARTMENT_TEACHERS_SUCCESS';
export const FETCH_DEPARTMENT_TEACHERS_FAILURE = 'FETCH_DEPARTMENT_TEACHERS_FAILURE';

export const FETCH_DEPARTMENT_STUDENTS_REQUEST = 'FETCH_DEPARTMENT_STUDENTS_REQUEST';
export const FETCH_DEPARTMENT_STUDENTS_SUCCESS = 'FETCH_DEPARTMENT_STUDENTS_SUCCESS';
export const FETCH_DEPARTMENT_STUDENTS_FAILURE = 'FETCH_DEPARTMENT_STUDENTS_FAILURE';

export const FETCH_MY_STUDENTS_REQUEST = 'FETCH_MY_STUDENTS_REQUEST';
export const FETCH_MY_STUDENTS_SUCCESS = 'FETCH_MY_STUDENTS_SUCCESS';
export const FETCH_MY_STUDENTS_FAILURE = 'FETCH_MY_STUDENTS_FAILURE';

export interface FetchDepartmentTeachersRequestAction {
  type: typeof FETCH_DEPARTMENT_TEACHERS_REQUEST;
}
export interface FetchDepartmentTeachersSuccessAction {
  type: typeof FETCH_DEPARTMENT_TEACHERS_SUCCESS;
  payload: any;
  count: number;
}
export interface FetchDepartmentTeachersFailureAction {
  type: typeof FETCH_DEPARTMENT_TEACHERS_FAILURE;
  payload: string;
}

export interface FetchDepartmentStudentsRequestAction {
  type: typeof FETCH_DEPARTMENT_STUDENTS_REQUEST;
}
export interface FetchDepartmentStudentsSuccessAction {
  type: typeof FETCH_DEPARTMENT_STUDENTS_SUCCESS;
  payload: any;
  count: number;
}
export interface FetchDepartmentStudentsFailureAction {
  type: typeof FETCH_DEPARTMENT_STUDENTS_FAILURE;
  payload: string;
}

export interface FetchMyStudentsRequestAction {
  type: typeof FETCH_MY_STUDENTS_REQUEST;
}
export interface FetchMyStudentsSuccessAction {
  type: typeof FETCH_MY_STUDENTS_SUCCESS;
  payload: any;
  count: number;
}
export interface FetchMyStudentsFailureAction {
  type: typeof FETCH_MY_STUDENTS_FAILURE;
  payload: string;
}

export type DepartmentDataActionTypes =
  | FetchDepartmentTeachersRequestAction
  | FetchDepartmentTeachersSuccessAction
  | FetchDepartmentTeachersFailureAction
  | FetchDepartmentStudentsRequestAction
  | FetchDepartmentStudentsSuccessAction
  | FetchDepartmentStudentsFailureAction
  | FetchMyStudentsRequestAction
  | FetchMyStudentsSuccessAction
  | FetchMyStudentsFailureAction;

const getErrorMessage = (error: any): string =>
  error?.response?.data?.message || error?.message || 'Something went wrong';

interface FilterParams {
  sort?:   string;
  search?: string;
  grade?:  string;
  page?:   number;
  school_id?: number;
}

export const fetchDepartmentTeachers = (token: string ,SubjectId : number, filters: FilterParams = {}) => {
  return async (dispatch: Dispatch<DepartmentDataActionTypes>): Promise<void> => {
     dispatch({ type: FETCH_DEPARTMENT_TEACHERS_REQUEST });
     try {
      const params = new URLSearchParams({
        type:       'view_department',
        subject_id: String(SubjectId),
      });
      if (filters.sort)   params.append('sort',   filters.sort);
      if (filters.search) params.append('search', filters.search);
      if (filters.page)   params.append('page',   String(filters.page));
      if (filters.school_id) params.append('school_id', String(filters.school_id)); // ← ONLY HERE
        const response = await api.get(`adminpage/access-control/hod/?${params.toString()}`, {
          headers: { Authorization: `Token ${token}` },
        });

        dispatch({
          type: FETCH_DEPARTMENT_TEACHERS_SUCCESS,
          payload: response?.data?.data,
          count: response?.data?.count ?? 0,
        });
     } catch (error) {
        dispatch({
          type: FETCH_DEPARTMENT_TEACHERS_FAILURE,
          payload: getErrorMessage(error),
        });
     }
  };
};

export const fetchDepartmentStudents = ({ token,SubjectId, filters={} }: { SubjectId: string | number; token: string, filters?:  FilterParams; }) => {
  return async (dispatch: Dispatch<DepartmentDataActionTypes>): Promise<void> => {
     dispatch({ type: FETCH_DEPARTMENT_STUDENTS_REQUEST });
     try {
       const params = new URLSearchParams({ subject_id: String(SubjectId) });
      if (filters.sort)   params.append('sort',   filters.sort);
      if (filters.search) params.append('search', filters.search);
      if (filters.grade)  params.append('grade',  filters.grade);
      if (filters.page)   params.append('page',   String(filters.page));
        const response = await api.get(`adminpage/access-control/get-students-by-subject/?${params.toString()}`, {
          headers: { Authorization: `Token ${token}` },
        });

        dispatch({
          type: FETCH_DEPARTMENT_STUDENTS_SUCCESS,
          payload: response?.data?.data,
          count: response?.data?.count ?? 0,
        });
     } catch (error) {
        dispatch({
          type: FETCH_DEPARTMENT_STUDENTS_FAILURE,
          payload: getErrorMessage(error),
        });
     }
  };
};

export const fetchMyStudents = (token: string, TeacherId:number, filters: FilterParams = {}) => {
  return async (dispatch: Dispatch<DepartmentDataActionTypes>): Promise<void> => {
     dispatch({ type: FETCH_MY_STUDENTS_REQUEST });
     try {
      const params = new URLSearchParams({
        type:       'enrolled_students',
        teacher_id: String(TeacherId),
      });
      if (filters.sort)   params.append('sort',   filters.sort);
      if (filters.search) params.append('search', filters.search);
      if (filters.grade)  params.append('grade',  filters.grade);
      if (filters.page)   params.append('page',   String(filters.page));
        const response = await api.get(`adminpage/access-control/teacher-and-enrolled/?${params.toString()}`, {
          headers: { Authorization: `Token ${token}` },
        });

        dispatch({
          type: FETCH_MY_STUDENTS_SUCCESS,
          payload: response?.data?.data,
          count: response?.data?.count ?? 0,
        });
     } catch (error) {
        dispatch({
          type: FETCH_MY_STUDENTS_FAILURE,
          payload: getErrorMessage(error),
        });
     }
  };
};